import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { CometChatUIKit, CometChatLocalize } from "@cometchat/chat-uikit-react";

export default function PrivateComponent() {
    const auth = localStorage.getItem('token');
    return auth ? <Outlet /> : <Navigate to="/login" />
}

